package com.eladfinish.bible.contest.screens.search.ui

import androidx.compose.foundation.text.InlineTextContent
import androidx.compose.foundation.text.appendInlineContent
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.KeyboardArrowDown
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberUpdatedState
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.LinkAnnotation
import androidx.compose.ui.text.Placeholder
import androidx.compose.ui.text.PlaceholderVerticalAlign
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.TextLinkStyles
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.text.withLink
import androidx.compose.ui.unit.em
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.extensions.formatWithCommas
import com.eladfinish.bible.contest.search_summary_books_format
import com.eladfinish.bible.contest.search_summary_one_book
import dev.icerock.moko.resources.compose.stringResource

private const val BOOKS_LINK_TAG = "books"
private const val BOOKS_ARROW_ID = "books_arrow"

/**
 * The line above the results: the summary of the search, then "in N books" as a link that opens
 * how many of the results are in each book. The link is left out while no result has a book.
 */
@Composable
internal fun SearchResultsSummary(
    summary: String,
    booksCount: Int,
    onBooksClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    val booksText = if (booksCount == 1) {
        stringResource(SharedRes.strings.search_summary_one_book)
    } else {
        stringResource(SharedRes.strings.search_summary_books_format, booksCount.formatWithCommas())
    }
    val linkColor = MaterialTheme.colorScheme.primary
    val currentOnBooksClick by rememberUpdatedState(onBooksClick)

    val text = remember(summary, booksCount, booksText, linkColor) {
        buildAnnotatedString {
            append(summary)
            if (booksCount > 0) {
                append(", ")
                withLink(
                    LinkAnnotation.Clickable(
                        tag = BOOKS_LINK_TAG,
                        styles = TextLinkStyles(
                            style = SpanStyle(
                                color = linkColor,
                                textDecoration = TextDecoration.Underline,
                            ),
                        ),
                        linkInteractionListener = { currentOnBooksClick() },
                    ),
                ) {
                    append(booksText)
                    appendInlineContent(BOOKS_ARROW_ID, "▾")
                }
            }
        }
    }

    Text(
        text = text,
        modifier = modifier,
        inlineContent = mapOf(
            BOOKS_ARROW_ID to InlineTextContent(
                placeholder = Placeholder(
                    width = 1.2.em,
                    height = 1.2.em,
                    placeholderVerticalAlign = PlaceholderVerticalAlign.TextCenter,
                ),
            ) {
                Icon(
                    imageVector = Icons.Default.KeyboardArrowDown,
                    contentDescription = null,
                    tint = linkColor,
                )
            },
        ),
    )
}
